/**
 * FileDetail shared styles — the seed of decomposition step F7
 * (CLAUDE.md §8.4). Holds only the generic style keys that both the
 * FileDetail view and its extracted cards read; F7 will move the
 * remaining keys of the view's `styles` object into this file.
 *
 * Every key here is verbatim from `views/FileDetail.jsx`. The view
 * re-attaches them into its own `styles` object as references, so no
 * call site in the view changes.
 */

export const sharedStyles = {
  metaLabel: {
    display: 'block',
    fontSize: '0.7rem',
    fontWeight: 600,
    color: 'var(--cp-text-muted)',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: '0.15rem',
  },
  section: {
    marginBottom: '1.5rem',
  },
  sectionTitle: {
    fontSize: '0.9rem',
    fontWeight: 600,
    color: 'var(--cp-text)',
    marginBottom: '0.5rem',
  },
  actionsTitle: {
    fontSize: '0.85rem',
    fontWeight: 600,
    color: 'var(--cp-text)',
    marginBottom: '0.75rem',
  },
  editCasesBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.3rem',
    padding: '0.25rem 0.6rem',
    background: 'transparent',
    border: '1px solid var(--cp-border)',
    borderRadius: '6px',
    color: 'var(--cp-primary)',
    fontSize: '0.75rem',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
};
